var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExpandTop18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.707 12.207a1 1 0 0 1-1.414-1.414l5-5a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414L9 7.914l-4.293 4.293z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiPjxwYXRoIGQ9Ik00LjcwNyAxMi4yMDdhMSAxIDAgMCAxLTEuNDE0LTEuNDE0bDUtNWExIDEgMCAwIDEgMS40MTQgMGw1IDVhMSAxIDAgMCAxLTEuNDE0IDEuNDE0TDkgNy45MTRsLTQuMjkzIDQuMjkzeiIvPjwvc3ZnPg==";
export { SvgExpandTop18 as ReactComponent };